import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "../../../services/data/data.service";
import { CookiesService } from "../../../tools/cookies.service";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { LoginModal } from "../login/login.component";

@Component({
    selector: "mobile-login-modal",
    template: require('./mobile-login-modal.component.html'),
    styles: [require('./mobile-login-modal.component.scss')]
})
export class MobileLoginModalComponent extends LoginModal {
    constructor(
        protected router: Router,
        protected fb: FormBuilder,
        public activeModal: NgbActiveModal,
        protected modalService: NgbModal,
        protected dataService: DataService,
        public workspaceService: WorkspaceServiceService
    ) {
        super(
            router,
            fb,
            activeModal,
            modalService,
            dataService,
            workspaceService
        );
    }
}
